<template lang="html">
<div>
  <Nav></Nav>
  <div class="section">
    <HelloWorld msg="Testing"/>
  </div>
</div>
</template>

<script>
import Nav from '@/components/Nav'
import HelloWorld from '@/components/HelloWorld'

export default {
  name: 'Home',
  components: {
    Nav,
    HelloWorld
  }
}
</script>
